// Phone number regex patterns and messages for different countries
export const COUNTRY_PHONE_PATTERNS = {
  Pakistan: {
    regex: /^((\+92)?(0)?3[0-9]{9})$/,
    example: "e.g. 03001234567",
    message: "Invalid Pakistani phone number. Use format: 03001234567",
  },
  Australia: {
    regex: /^((\+61)?(0)?[2-478][0-9]{8})$/,
    example: "e.g. 0412345678",
    message: "Invalid Australian phone number. Use format: 0412345678",
  },
  "United States": {
    regex: /^((\+1)?[2-9][0-9]{9})$/,
    example: "e.g. 2025550123",
    message: "Invalid US phone number. Must be 10 digits",
  },
  Canada: {
    regex: /^((\+1)?[2-9][0-9]{9})$/,
    example: "e.g. 4165550123",
    message: "Invalid Canadian phone number. Must be 10 digits",
  },
  "United Kingdom": {
    regex: /^((\+44)?(0)?7[0-9]{9})$/,
    example: "e.g. 07123456789",
    message: "Invalid UK mobile number. Use format: 07123456789",
  },
  "Saudi Arabia": {
    regex: /^((\+966)?(0)?5[0-9]{8})$/,
    example: "e.g. 0512345678",
    message: "Invalid Saudi phone number. Use format: 0512345678",
  },
  "United Arab Emirates": {
    regex: /^((\+971)?(0)?5[0-9]{8})$/,
    example: "e.g. 0512345678",
    message: "Invalid UAE phone number. Use format: 0512345678",
  },
  India: {
    regex: /^((\+91)?(0)?[6-9][0-9]{9})$/,
    example: "e.g. 9876543210",
    message: "Invalid Indian mobile number. Use format: 9876543210",
  },
};

// Fallback international phone pattern
export const FALLBACK_PHONE_PATTERN = {
  regex:
    /^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/,
  example: "e.g. +1234567890",
  message: "Phone number is not valid. Use format: +1234567890",
};
